<div>
	<label class="text-center text-tertiary fw-semibold w-100 my-3">
		Pluviometria (mm) - {{ periodoTitulo }}
	</label>

	<div id="mapa-legenda">
		<div class="d-flex">
			<div class="col-12 pe-lg-0 pe-1" style="max-height: 500px">
				<div class="mapa-wrapper">
					<seira-mapa-paraiba-leaflet
						(mapaEmitter)="setupMap($event)"
						[loading]="carregando"
						[monitoramentoMapa]="map" />
				</div>
			</div>
		</div>

		<div id="legenda-export">
			<seira-legenda-mapa [legendaInfo]="legenda"></seira-legenda-mapa>
		</div>
	</div>

	<seira-card-info
		aditionalClasses="my-2"
		[texto]="descricaoRelatorio"></seira-card-info>
</div>
